export default "__VITE_ASSET__Cp85Cz6E__"